import React, { FC } from 'react';
import { NameUtils } from '@oh-vcp/components-common';
import { ActionItemParams } from '@oh-vcp/components-ui';
import useProgramLookup from '../services/useProgramLookup';
import usePeopleProfileQuery from '../services/usePeopleProfileQuery';
import EconsultAction from '../actions/EconsultAction';

interface EconsultFavRequestConsultProps {
  category: string;
  userId?: string;
  programId?: string;
  programStatus?: string;
  programReferrers?: string;
  unavailability?: string;
  onActionComplete?: () => void;
  keepFavMenuOpen?: () => void;
}

const EconsultFavRequestConsult: FC<EconsultFavRequestConsultProps> = ({
  userId,
  programId,
  category,
  programStatus,
  programReferrers,
  unavailability,
  onActionComplete,
  keepFavMenuOpen
}) => {
  const isProgramProfile = category !== 'CONTACT';
  const { data: userDetails } = usePeopleProfileQuery(userId);
  const { data: programDetails } = useProgramLookup(
    programId ? parseInt(programId, 10) : undefined
  );
  const actionParams: ActionItemParams = {
    profileType: category === 'CONTACT' ? 'people' : 'program',
    userId,
    userName: NameUtils.makeName(
      userDetails?.lastName || '',
      userDetails?.firstName,
      userDetails?.salutation,
      userDetails?.specialty,
      userDetails?.middleName,
      null,
      null,
      null,
      null
    ),
    programId,
    programName: programDetails?.programName,
    programStatus,
    programType: programDetails?.programType,
    unavailability,
    programSpecialtyOptions: programDetails?.specialtyOptions,
    programRegionName: programDetails?.regionName,
    programRegionId: programDetails?.regionId?.toString(),
    programReferrers,
    onActionComplete
  };

  if (isProgramProfile && !programDetails) {
    return null;
  }

  return (
    <EconsultAction
      actionType="menu"
      params={actionParams}
      keepFavMenuOpen={keepFavMenuOpen}
      translationKey=""
      openInCurrentTab
      minimal
    />
  );
};

export default EconsultFavRequestConsult;
